import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { connect } from "react-redux";
import { envelopeType } from "custom-prop-types";
import { ManageEnvelopes } from "components/manage-envelopes/manage-envelopes";
import {
  requestEnvelopeAction,
  setCoversheetAction,
  setRequestEnvelopeVisibilityAction,
  setSendEnvelopeVisibilityAction
} from "actions/envelopes-actions";
import { trackPageAction } from "actions/shared/tracking-actions";
import { addEnvelopeToFilterAction } from "actions/document-filters-actions";
import { setFlashMessageAction } from "actions/app-actions";
import { Loading } from "components/common/loading";

class ManageEnvelopesPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
    this.props.trackPage();
  }

  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    return (
      <ManageEnvelopes
        { ...this.props }
        envelopes={ mapEnvelopeUploadedKey(this.props.envelopes) }
        isAwaitingMailin={ false }
        isLinkable
        title="Envelope History"
      />
    );
  }
}

ManageEnvelopesPage.defaultProps = {
  envelopes: []
};

ManageEnvelopesPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  envelopes: PropTypes.arrayOf(envelopeType),
  init: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  trackPage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  coversheetUrl: state.envelopes.coversheetUrl,
  envelopes: state.envelopes.envelopes,
  isLoading: state.envelopes.isLoading,
  isRequestEnvelopeVisible: state.envelopes.isRequestEnvelopeVisible,
  isSendEnvelopeVisible: state.envelopes.isSendEnvelopeVisible,
  slug: state.app.selectedAccount.slug
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(setCoversheetAction(accountId)),
  trackPage: () => dispatch(trackPageAction("Manage envelopes page")),
  onAddEnvelope: (code) => dispatch(addEnvelopeToFilterAction(code)),
  onHideRequestEnvelope: () => dispatch(setRequestEnvelopeVisibilityAction(false)),
  onHideSendEnvelope: () => dispatch(setSendEnvelopeVisibilityAction(false)),
  onRequestEnvelope: (accountId) => dispatch(requestEnvelopeAction(accountId)),
  onSetFlashMessage: (message) => dispatch(setFlashMessageAction(message)),
  onShowRequestEnvelope: () => dispatch(setRequestEnvelopeVisibilityAction(true)),
  onShowSendEnvelope: () => dispatch(setSendEnvelopeVisibilityAction(true))
});

export const ManageEnvelopesContainer = connect(mapStateToProps, mapDispatchToProps)(ManageEnvelopesPage);

export const mapEnvelopeUploadedKey = (envelopes) => envelopes.map((envelope) => (
  R.assoc("envelopeUploaded", envelope.uploaded, envelope)
));



// WEBPACK FOOTER //
// ./src/js/containers/manage-envelopes-container.jsx